import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import charactersData from '../data/characters.json';

function CharacterDetail() {
  const { id } = useParams();
  const [character, setCharacter] = useState(null);

  useEffect(() => {
    const found = charactersData.find(char => char.id === id);
    if (found) {
      setCharacter(found);
    }
  }, [id]);

  if (!character) return <div>Loading...</div>;

  return (
    <div className="character-detail">
      <Link to="/">Back to Select</Link>
      <h2>{character.name}</h2>
      <div className="variations">
        {character.variations.map((variation, i) => (
          <div key={i} className="variation">
            <h3>{variation.title}</h3>
            <img src={variation.image} alt={variation.title} />
            <p>{variation.description}</p>

            {variation.video && (
              <video width="320" height="240" controls>
                <source src={variation.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            {variation.audio && (
              <audio controls>
                <source src={variation.audio} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CharacterDetail;
